import {Injectable, Inject} from "@angular/core";
import * as $ from 'jquery';

declare var ramjet: any;

@Injectable()
export class HeroAnimationService {

  constructor(@Inject('isBrowser') protected isBrowser: boolean) {}

  private _elementFrom = null;
  private _elementTo = null;
  private _movingList = [];
  private _doneList = [];
  private _cancelled = false;

  public registerStartAnimationEvent(event) {
    if(this.isBrowser) {
      if (event.fromState == 'void') {
        this._elementTo = event.element;
      }
      else {
        this._elementFrom = event.element;
      }
      if (this._elementFrom != null && this._elementTo != null) {
        this.transform();
      }
    }
  }

  protected transform() {

    $(this._elementFrom).addClass('hero-leave');
    $(this._elementFrom).removeClass('hero-enter');
    $(this._elementTo).addClass('hero-enter');
    $(this._elementTo).removeClass('hero-leave');

    let fromHeros = this._elementFrom.getElementsByClassName("hero-ramjet");
    let toHeros = this._elementTo.getElementsByClassName("hero-ramjet");

    for (var m = 0; m < toHeros.length; m++) {
      $(toHeros[m]).addClass('hero-ramjet-inactive');
    }

    // Find all the matching pairs
    let pairs = [];
    let visited = {};
    for (let n = 0; n < fromHeros.length; n++) {
      for (let m = 0; m < toHeros.length; m++) {
        if (fromHeros[n].getAttribute('hero-id') === toHeros[m].getAttribute('hero-id')) {
          if(!visited.hasOwnProperty(fromHeros[n].getAttribute('hero-id'))) {
            visited[fromHeros[n].getAttribute('hero-id')] = true;
            $(toHeros[m]).removeClass('hero-ramjet-inactive');
            pairs.push({from: fromHeros[n], to: toHeros[m]});
          }
        }
      }
    }

    // Trigger the animation for each pair
    pairs.forEach((pair) => {
      this.animateHero(pair.from, pair.to);
    });

    this.finish();

  }

  protected animateHero(fromHero, toHero) {
    //ramjet.hide(fromHero);
    //ramjet.hide(toHero);
    let handler = {
      complete: false,
      onComplete: () => {
        handler.complete = true;
        this.finish();
      },
      remove: () => {
        ramjet.show(fromHero);
        ramjet.show(toHero);
      }
    };
    this._movingList.push(handler);
    ramjet.transform(fromHero, toHero, {
      done: handler.onComplete,
      duration: 500
    });
  }

  protected finish() {
    // Check that all the moving elements are complete
    let allComplete = true;
    if (!this._cancelled) {
      this._movingList.forEach((m) => { allComplete = allComplete && m.complete; });
    }

    if (allComplete) {
      this.clear();
    }
  }

  protected clear() {

    if (this._elementFrom != null) {
      $(this._elementFrom).removeClass('hero-leave');
    }
    if (this._elementTo != null) {
      $(this._elementTo).removeClass('hero-enter');
    }

    this._elementFrom = null;
    this._elementTo = null;
    this._doneList = [];

    // Call remove for each animating hero element
    if (this._movingList) this._movingList.forEach( (m) => { m.remove(); });
    this._movingList = [];

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/animations/hero-animation.service.ts